import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { DonationCallRequestService } from '../../../../../app/shared/API-Service/services/donation-call-request.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-view-donation-call-request',
  templateUrl: './view-donation-call-request.component.html',
  styleUrls: ['./view-donation-call-request.component.css']
})
export class ViewDonationCallRequestComponent implements OnInit {
  Donationcallrequest:object [] = [];
  constructor(private _DonationCallRequestService:DonationCallRequestService,private _Router:Router) { }

  ngOnInit(): void {
    this.getdonationcallrequest();
  }
  getdonationcallrequest(){
    this._DonationCallRequestService.GetDonationCallRequest().subscribe((res) => {
      this.Donationcallrequest = res.data
    console.log(this.Donationcallrequest);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  
  update(data){
    this._DonationCallRequestService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertDonationCallRequest']);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._DonationCallRequestService.DeleteDonationCallRequest(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getdonationcallrequest();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
      
}
